import { Badge } from "@/components/ui/badge";
import { statusMeta } from "../features/directory/statuses";

const TONE_VARIANT = {
  positive: "default",
  warning: "outline",
  muted: "secondary",
  neutral: "outline",
  error: "destructive",
};

export function StatusBadge({ statuses, value }) {
  const { label, tone } = statusMeta(statuses, value);
  return (
    <Badge variant={TONE_VARIANT[tone] || "outline"} className="capitalize">
      {label}
    </Badge>
  );
}
